<template>
    <transition name="modal">
        <div 
            id="modal-default" 
            class="modal d-block modal-mask box-shadow">
            <div 
                :style="browser.name === 'ie' ? { margin: 0 } : {}"
                class="modal-dialog"
                role="document">
                <div class="modal-content">
                    <div class="modal-header bg-dark text-white text-uppercase box-header with-border">
                        <slot name="header"/>
                    </div>
                    <div class="modal-body">
                        <slot name="body"/>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer"/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import browserDetect from 'browser-detect';

export default {
    data() {
        return {
            browser: browserDetect()
        };
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modal.vue